import { createSlice } from "@reduxjs/toolkit";
import { fetchUpcomingBookings } from "./bookingThunks";

const initialState = {
  list: [],
  pagination: {},
  loading: false,
  error: null,
};

const bookingSlice = createSlice({
  name: "bookings",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchUpcomingBookings.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchUpcomingBookings.fulfilled, (state, action) => {
        state.loading = false;
        state.list = action.payload.bookings;
        state.pagination = action.payload.pagination;
      })
      .addCase(fetchUpcomingBookings.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export default bookingSlice.reducer;
